/* eslint-disable no-undef */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Styles } from './style';
import { Agent, agentData } from '../UserList/agentData';
import AuthenticatedLayout from '@screens/Authenticated/Layout/Layout';

const UserRegisterScreen: React.FC = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState<
    Omit<Agent, 'id' | 'createdAt' | 'updatedAt'>
  >({
    userType: 'Corretor',
    agentName: '',
    agentPhoto: '',
    phone: '',
    email: '',
    agentCode: '',
    propertiesManaged: []
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/usuarios');
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <AuthenticatedLayout>
      <h1>CADASTRO DE NOVO USUÁRIO</h1>
      <Styles.RectangleBar />
      <form onSubmit={handleSubmit}>
        <Styles.FormSection>
          <Styles.InputContainer>
            <Styles.Label>Nome Completo *</Styles.Label>
            <Styles.Input
              name="agentName"
              value={formData.agentName}
              onChange={handleChange}
              required
            />
          </Styles.InputContainer>
          <Styles.InputContainer>
            <Styles.Label>Tipo de Usuário *</Styles.Label>
            <Styles.Select
              name="userType"
              value={formData.userType}
              onChange={handleChange}
              required>
              <option value="Corretor">Corretor</option>
              <option value="Secretária">Secretária</option>
              <option value="Administrador">Administrador</option>
              <option value="Proprietário">Proprietário</option>
            </Styles.Select>
          </Styles.InputContainer>
          <Styles.InputContainer>
            <Styles.Label>Código *</Styles.Label>
            <Styles.Input
              name="agentCode"
              value={formData.agentCode}
              onChange={handleChange}
              required
            />
          </Styles.InputContainer>
        </Styles.FormSection>
        <Styles.FormSection>
          <Styles.InputContainer>
            <Styles.Label>Telefone *</Styles.Label>
            <Styles.Input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </Styles.InputContainer>
          <Styles.InputContainer>
            <Styles.Label>E-mail *</Styles.Label>
            <Styles.Input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </Styles.InputContainer>
        </Styles.FormSection>
        <Styles.FormSection>
          <Styles.InputContainer>
            <Styles.Label>URL da Foto</Styles.Label>
            <Styles.Input
              type="url"
              name="agentPhoto"
              value={formData.agentPhoto}
              onChange={handleChange}
            />
          </Styles.InputContainer>
          {formData.agentPhoto && (
            <div style={{ marginLeft: '20px' }}>
              <img
                src={formData.agentPhoto}
                alt="Preview"
                style={{
                  width: '100px',
                  height: '100px',
                  borderRadius: '50%',
                  objectFit: 'cover'
                }}
              />
            </div>
          )}
        </Styles.FormSection>
      </form>
      <Styles.FormSection>
        <Styles.Button type="submit">SALVAR</Styles.Button>
        <Styles.CancelButton type="button" onClick={() => navigate(-1)}>
          CANCELAR
        </Styles.CancelButton>
      </Styles.FormSection>
    </AuthenticatedLayout>
  );
};

export default UserRegisterScreen;
